import React, { useState } from 'react';
import { AlertSnackBarSeverity } from 'src/constants/index';

export const useAlertSnackBar = () => {
  const [alertSnackBarOpen, setAlertSnackBarOpen] = useState(false);
  const [alertSnackBarDuration, setAlertSnackBarDuration] = useState<number>(0);
  const [alertSnackBarSeverity, setAlertSnackBarSeverity] = useState(
    AlertSnackBarSeverity.SUCCESS,
  );
  const [alertSnackBarMessage, setAlertSnackBarMessage] = useState('');

  const openAlertSnackBar = (
    duration: number,
    severity: string,
    message: string,
  ) => {
    setAlertSnackBarOpen(true);
    setAlertSnackBarDuration(duration);
    setAlertSnackBarSeverity(severity);
    setAlertSnackBarMessage(message);
    setTimeout(() => {
      setAlertSnackBarOpen(false);
    }, duration);
  };

  return {
    alertSnackBarOpen,
    alertSnackBarDuration,
    alertSnackBarSeverity,
    alertSnackBarMessage,
    openAlertSnackBar,
    setAlertSnackBarOpen,
  };
};
